<template>
  <EditFormDialog
    :formData="formData"
    :rules="rules"
    :formType="'add'"
    :loading="loading"
    @submitForm="submitForm"
    @closeDialog="closeDialog"
    v-bind="$attrs"
    v-on="$listeners"
  >

    <el-form-item label="对接平台的组织机构代码" prop="companyCode">
      <el-input v-model="formData.companyCode" maxlength="32" show-word-limit style="width:90%" autocomplete="off" placeholder="请填写"
                clearable></el-input>
    </el-form-item>

    <el-form-item label="公司名称">
      <el-input v-model="formData.companyName" autocomplete="off" placeholder="请填写"

                maxlength="50"
                show-word-limit
                type="textarea"
                :rows="3"
                clearable></el-input>
    </el-form-item>

    <el-form-item label="对接URL" prop="companyUrl">
      <el-input v-model="formData.companyUrl" autocomplete="off" placeholder="请填写"

                maxlength="100"
                show-word-limit
                type="textarea"
                :rows="3"
                clearable></el-input>
    </el-form-item>
    <el-form-item label="推送URL" prop="pushUrl">
      <el-input v-model="formData.pushUrl" autocomplete="off" placeholder="请填写"

                maxlength="100"
                show-word-limit
                type="textarea" :rows="3"
                clearable></el-input>
    </el-form-item>


    <el-form-item label="对接描述">
      <el-input v-model="formData.description" autocomplete="off"
                maxlength="100"
                show-word-limit
                type="textarea" :rows="3"
                placeholder="请填写"></el-input>
    </el-form-item>

    <el-form-item label="运营商名称">
      <el-input v-model="formData.operatorName" autocomplete="off"
                maxlength="100"
                show-word-limit
                type="textarea"
                :rows="3"
                placeholder="请填写"></el-input>
    </el-form-item>

    <el-form-item label="运营商简称">
      <el-input v-model="formData.operatorBname" autocomplete="off"
                maxlength="100"
                show-word-limit
                type="textarea"
                :rows="3"
                placeholder="请填写"></el-input>
    </el-form-item>

    <el-form-item label="运营商客服电话">
      <el-input v-model="formData.operatorTel1" autocomplete="off"
                maxlength="100"
                show-word-limit
                type="textarea"
                :rows="3"
                placeholder="请填写"></el-input>
    </el-form-item>

    <el-form-item label="运营商注册地址">
      <el-input v-model="formData.operatorRegAddress" autocomplete="off"
                maxlength="100"
                show-word-limit
                type="textarea"
                :rows="3"
                placeholder="请填写"></el-input>
    </el-form-item>

    <el-form-item label="是否有效" prop="isAvailable">
      <el-select v-model="formData.isAvailable"  placeholder="选择是否">
        <el-option v-for="item in searchData.yesOrNo" :key="item.value" v-bind:label="item.message"
                   v-bind:value="item.value"/>
      </el-select>
    </el-form-item>

    <el-form-item label="共享站点名称" prop="sites">
      <el-select @remove-tag="removeTag" @change="selectStation" @clear="clearAll"  size="medium" v-model="formData.sites" clearable multiple placeholder="请选择站点" class="userRole">
        <el-option v-for="item in searchData.stations" :key="item.id" v-bind:label="item.stationName"
                   v-bind:value="item.id">
        </el-option>
      </el-select>
      <template>
        <el-checkbox @change="selectSites" v-model="checked">全选</el-checkbox>
      </template>
    </el-form-item>

    <el-form-item label="开放接口" prop="interfaces">
      <el-select v-model="formData.interfaces" multiple placeholder="请选择接口">
        <el-option v-for="item in searchData.interfaceNames" :key="item.interfaceName"
                   v-bind:label="item.interfaceName" v-bind:value="item.interfaceName">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="运营商的组织结构代码" prop="operatorid">
      <el-input v-model="formData.operatorid" maxlength="64" show-word-limit style="width:90%" autocomplete="off" placeholder="请填写"
                clearable></el-input>
    </el-form-item>

    <el-form-item label="运营商统一社会信用代码" prop="operatorUSCID">
      <el-input v-model="formData.operatorUSCID" maxlength="20" show-word-limit style="width:90%" autocomplete="off" placeholder="请填写"
                clearable></el-input>
    </el-form-item>

    <el-form-item label="运营商秘钥" prop="operatorSecret">
      <el-input v-model="formData.operatorSecret" maxlength="64" show-word-limit style="width:90%" autocomplete="off" placeholder="请填写"
                clearable></el-input>
    </el-form-item>

    <el-form-item label="消息秘钥" prop="dataSecret">
      <el-input v-model="formData.dataSecret" maxlength="64" show-word-limit style="width:90%" autocomplete="off" placeholder="请填写"
                clearable></el-input>
    </el-form-item>

    <el-form-item label="消息秘钥向量" prop="dataSecretIv">
      <el-input v-model="formData.dataSecretIv" maxlength="16" show-word-limit style="width:90%" autocomplete="off" placeholder="请填写"
                clearable></el-input>
    </el-form-item>

    <el-form-item label="签名秘钥" prop="sigSecret">
      <el-input v-model="formData.sigSecret" maxlength="64" show-word-limit style="width:90%" autocomplete="off" placeholder="请填写"
                clearable></el-input>
    </el-form-item>

  </EditFormDialog>
</template>
<script>
    import api from '@/module/interactionCenter/api/cec.js'
    import EditFormDialog from '@/components/EditFormDialog'
    import { validateInput} from '../../../../../common/validator'
    export default {
        props: {
            searchData: {
                type: Object,
                required: true
            }
        },
        components: {
            EditFormDialog
        },
        data() {
            const cForm = {
                id: '',
                companyCode: '',
                companyName: '',
                companyUrl: '',
                pushUrl: '',
                isAvailable: '',
                description: '',
                createTime: '',
                operatorid: '',
                operatorName: '',
                operatorBname:'',
                operatorTel1:'',
                operatorRegAddress:'',
                dataSecretIv: '',
                operatorSecret: '',
                dataSecret: '',
                sigSecret: '',
                sites: [],
                interfaces: []
            }
            return {
                checked:false,
                loading: false, // 是显示加载
                dialogImageUrl: '',
                dialogVisible: false,
                fileList: [],
                position: [],
                filterPosition: null,
                currentPosition: null,
                // 表单
                cForm: cForm,
                formData: Object.assign({}, cForm),
                // rules表单验证
                rules: {
                    companyCode: [{required: true, message: '请输入组织机构代码', trigger: 'blur'},
                        {max: 9, message: '组织机构代码不能超过9位', trigger: 'blur'}],
                    companyUrl: [{required: true, message: '请输入对接URL', trigger: 'blur'},
                        {
                            validator: function (rule, value, callback) {
                                validateInput(rule, value, callback, 0, 100, true, false, true, false, false, false, false)
                            },required: true, trigger: 'blur'
                        }
                        ],
                    pushUrl: [{required: true, message: '请输入推送URL', trigger: 'blur'},
                        {
                            validator: function (rule, value, callback) {
                                validateInput(rule, value, callback, 0, 100, true, false, true, false, false, false, false)
                            },required: true, trigger: 'blur'
                        }
                        ],
                    isAvailable: [{required: true, message: '请选择是否有效', trigger: 'blur'}],
                    operatorid: [{required: true, message: '请输入运营商id', trigger: 'blur'},
                        {
                            validator: function (rule, value, callback) {
                                validateInput(rule, value, callback, 0, 9, true, false, true, false, false, false, false)
                            },required: true, trigger: 'blur'
                        }
                        ],
                    sites: [{required: true, message: '请选择共享站点', trigger: 'blur'}],
                    interfaces: [{required: true, message: '请选择开放接口', trigger: 'blur'}],
                    operatorSecret:[{
                        validator: function (rule, value, callback) {
                            validateInput(rule, value, callback, 0, 64, true, false, true, false, false, false, false)
                        },required: false, trigger: 'blur'
                    }],
                    dataSecret:[{
                        validator: function (rule, value, callback) {
                            validateInput(rule, value, callback, 0, 64, true, false, true, false, false, false, false)
                        },required: false, trigger: 'blur'
                    }],
                    dataSecretIv:[{
                        validator: function (rule, value, callback) {
                            validateInput(rule, value, callback, 0, 64, true, false, true, false, false, false, false)
                        },required: false, trigger: 'blur'
                    }],
                    sigSecret:[{
                        validator: function (rule, value, callback) {
                            validateInput(rule, value, callback, 0, 64, true, false, true, false, false, false, false)
                        },required: false, trigger: 'blur'
                    }]
                }

            }
        },
        created() {
        },
        computed: {},
        watch: {},
        methods: {

          selectSites(dx){
            let siteIds = [];
            if(dx){
              this.searchData.stations.forEach(function(val){
                //console.log(val.id+"-"+val.stationName+"\n");
                siteIds.push(val.id);
              });
              this.formData.sites=siteIds;
            }else{
              this.formData.sites=siteIds;
            }
          },
          /**/
          selectStation(val){
            console.log(val);
            console.log(this.formData.sites);
            //this.searchData.stations
            if (this.searchData.stations.length !== this.formData.sites.length) {
              this.checked = false;
            } else {
              this.checked = true;
            }
          },
          /*移除select的tag*/
          removeTag(value){
            console.log(value);
            this.checked = false;
          },
          clearAll(){
            this.checked = false;
          },
            // 关闭弹框
            closeDialog() {
                this.resetForm()
                this.$emit('closeDialog', 'add')
            },
            // 重置表单
            resetForm() {
                this.formData = JSON.parse(JSON.stringify(this.cForm))
            },
            // 编辑、添加提交方法
            submitForm() {
                this.loading = true
                api.insertCec(this.formData).then((res) => {
                    if (res.code === 0) {
                        this.$message({
                            type: 'success',
                            message: '添加成功！'
                        })
                        this.$emit('afterAdd')
                    } else {
                        this.$message.error(res.message)
                    }
                }).finally(() => {
                    this.loading = false
                })
            },
        }
    }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/module/interactionCenter/page/cec/cec/add.vue